<template>
  <div class="clock">
    <div class="datetime-content">
      <ul>
        <li class="clock-digit">{{hours}}</li>
        <li class="clock-digit">:</li>
        <li class="clock-digit">{{mins}}</li>
        <li class="clock-digit" id="point">:</li>
        <li class="clock-digit">{{secs}}</li>
      </ul>
    </div>
    <div class="datetime-content">
      <div id="Date" class="text-primary-brink-darkpurple">{{dateStr}}</div>
    </div>
  </div>
</template>

<script>
import dateHelper from "@mixins/dateHelper"
export default {
  name: "NavClock",
  mixins: [dateHelper],
  data(){
    return {
      hours: null,
      mins: null,
      secs: null,
      dateStr: null,
    }
  },
  mounted() {
    this.updateTime()
    this.startTimer();
  },
  methods: {
    startTimer(){
      setInterval(() => {
        this.updateTime()
      }, 1000)
    },
    updateTime(){
      const t = new Date()
      this.hours = this.toDigits(t.getHours())
      this.mins = this.toDigits(t.getMinutes())
      this.secs = this.toDigits(t.getSeconds())

      this.dateStr = this.midDateFormat(t)
    },
    toDigits(n){
      return n > 9 ? "" + n: "0" + n;
    }
    
  }

}
</script>